// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"448d35c3","453":"8f7715c9","667":"5724b17e","963":"5d67a686"}[chunkId] + ".chunk.js";
};